// extracted by mini-css-extract-plugin
export var hidden = "_uv-0";